import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../lib/cn.js";
/** docs/design.md §3.7 — loading rows, resolving within 2s to data or an explicit empty state, never an indefinite spinner. */
export function Skeleton({ className, ...props }) {
    return (_jsx("div", { className: cn("motion-safe:animate-pulse rounded-sm bg-surface-hover", className), "aria-hidden": "true", ...props }));
}
//# sourceMappingURL=skeleton.js.map